/**
 *
 * @type {object}
 * @property {HTMLBodyElement} body - fast access to the body element
 * @property {HTMLElement[]} focusable - elements that are focusable
 * @property {HTMLElement[]} modalTrigger - any element that can trigger a modal
 * @property {HTMLElement[]} closeModal - any element that can close a modal
 * @property {HTMLElement[]} closeAnyModal - any element that will close ANY modal
 * @property {HTMLElement[]} closeButton - any element that is a close button.
 * @property {boolean} prefersReducedMotion - if the user prefers reduced motion
 * @property {boolean} prefersMotion - if the use prefers motion
 */
const Dom = {};
const getters = {
    'body'              : ()=>document.body,

    // accesibility
    'focusable'         : ()=>document.querySelectorAll("a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), object, embed, *[tabindex], *[contenteditable], *[data-notab]"),
    // Modal
    'modalTrigger'      : ()=>document.querySelectorAll('[data-modal-target]'),
    'closeModal'        : ()=>document.querySelectorAll('.modal__close'),
    'closeAnyModal'     : ()=>document.querySelectorAll('[data-dismiss="allModal"]'),
    'closeButton'       : ()=>document.querySelectorAll('[close-button]'),

    'prefersReducedMotion': ()=>matchMedia('(prefers-reduced-motion: reduce)').matches,
    'prefersMotion': ()=>matchMedia('(prefers-reduced-motion: no-preference)').matches,
    'hasMouse': ()=>matchMedia('(pointer:fine)').matches,
}
// Creates a set of getters that will fetch a fresh value each time that it is accessed.
Object.entries(getters).forEach(([key,getter])=>{
    Object.defineProperty(Dom, key, {
        get: getter,
    })
});


export default Dom;